import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list, Mix } from "Utils/Reflection";
import * as Constants from "Data/Constants";

import {hh_ch1_p08} from "../../../layouts/ch1_p08/hh_ch1_p08";

export class Chapter1Page8 extends AbstractStoryState {

	readonly background = this.addChild(new SceneSprite());
	readonly kitchen = this.addChild(new SceneSprite());
	readonly doorframe = this.addChild(new SceneSprite());
	readonly hollyBack = list(()=>this.addChildAt(new SceneSprite(), 2));
	readonly stairs = this.addChild(new SceneSprite());
	readonly table = this.addChild(new SceneSprite());
	readonly hollyFront = list(()=>this.addChildAt(new SceneSprite(), 6));
	readonly frame = list(()=>this.addChild(SceneSprite.withPrefix("ch1_p08/")));

	protected dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
		hh_ch1_p08.call(this);
		// hide objects that are just for positioning
		this.hollyBack[0].visible = false;
		this.hollyFront[0].visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
	}

	protected onAnimateInComplete() {
		super.onAnimateInComplete();
		TweenLite.delayedCall(1.5, ()=>this.gotoNextState({transition: "up"}));
	}
}